import { print } from 'graphql'
import gql from 'graphql-tag'

import axiosql from '../axiosql'

function load() {
    return axiosql('admin/graphql', {
        query: print(gql`
            {
                site {
                    register
                    login
                    access
                    blacklistDomains
                    blacklistKeywords
                    refererCredit
                    refereeCredit
                }
            }
        `)
    })
}

function save(site) {
    return axiosql('admin/graphql', {
        query: print(gql`
            mutation applySiteSettings(
                $register: Boolean!
                $login: Boolean!
                $access: Boolean!
                $blacklistDomains: [String]!
                $blacklistKeywords: [String]!
                $refererCredit: Int
                $refereeCredit: Int
            ) {
                updateSite(
                    data: {
                        register: $register
                        login: $login
                        access: $access
                        blacklistDomains: $blacklistDomains
                        blacklistKeywords: $blacklistKeywords
                        refererCredit: $refererCredit
                        refereeCredit: $refereeCredit
                    }
                ) {
                    access
                }
            }
        `),
        variables: {
            register: site.register,
            login: site.login,
            access: site.access,
            blacklistDomains: site.blacklistDomains,
            blacklistKeywords: site.blacklistKeywords,
            refererCredit: parseInt(site.refererCredit),
            refereeCredit: parseInt(site.refereeCredit)
        }
    })
}

export { load, save }
